module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10187.527f0d8b.jpg";